import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@material-ui/core/Grid";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {CardShopStructList} from "../structs/CardShopStructList";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import Button from "@material-ui/core/Button";
import {Snackbar} from "@material-ui/core";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Typography from "@material-ui/core/Typography";
import {BackButton, FormPropsTextFields} from './HookUtils'
import {Link} from "react-router-dom";
import Location from "../assets/icons/location.svg";
import EmptyShopCard from "../assets/icons/empty_shopcard.jpg";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AvatarRound from "../assets/icons/avatar_round.svg";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class CardShopComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardShopList: [],
            totalOrder: 0,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            userData: null,
        }
    }

    componentDidMount() {
        this.getCardShop()

        this.getUserData()

    }

    getUserData() {
        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data, name: results.data.name, address: results.data.address})
                    }


                },
                (error) => {
                    console.log("error")

                }
            );
    }

    getCardShop() {
        if (CardShopRepository.getAll() !== null) {
            let cardShopList = []

            CardShopRepository.getAll().forEach(function (item) {
                let check = false;

                cardShopList.forEach(function (item2) {
                    if (item.product.markets.id === item2.market.id) {

                        if (item.product.price > 0) {
                            item2.total += (parseInt(item.product.price) - parseInt(item.product.del_price)) * item.count
                        }

                        item2.productList.push(item)
                        check = true
                    }
                })


                if (!check) {
                    let cardShopStructList = new CardShopStructList()
                    cardShopStructList.market = item.product.markets

                    if (item.product.price > 0) {
                        cardShopStructList.total += (parseInt(item.product.price) - parseInt(item.product.del_price)) * item.count
                    }

                    cardShopStructList.productList.push(item)

                    cardShopList.push(cardShopStructList)
                }
            })

            let sum = 0;
            cardShopList.forEach(function (item) {
                sum += (parseInt(item.total) + parseInt(item.market.shipping))
            })

            this.setState({totalOrder: sum})

            this.setState({cardShopList: cardShopList})
        }

    }

    render() {
        const handleOnDecrease = (product) => {
            CardShopRepository.decreaseCardShop(product.product)

            this.getCardShop()
        };

        const handleOnIncrease = (product) => {
            let findCardShop = CardShopRepository.getItem(product.product.id)

            let totalEntity = parseInt(findCardShop.count)
            if (totalEntity < parseInt(product.product.step)) {
                if (product.product.price > 0) {
                    CardShopRepository.addCardShop(product.product)

                    this.getCardShop()
                } else {
                    this.setState({openSnackbar: true, message: "جهت خرید کالا تماس بگیرید.", snackbarType: "error"})
                }

            } else {
                this.setState({openSnackbar: true, message: "موجودی کالا به اتمام رسیده!", snackbarType: "error"})

            }


        };

        const MAX_LENGTH = 50;
        const onPaymentCLicked = () => {
            const list = CardShopRepository.getAll();

            if (this.state.name===null || this.state.name===""){
                this.setState({openSnackbar: true, message: "ابتدا نام و نام خانوادگی را تکمیل کنید!", snackbarType: "error"})
                return
            }

            if (this.state.address===null || this.state.address===""){
                this.setState({openSnackbar: true, message: "ابتدا آدرس خودرا از منوی پروفایل تکمیل کنید!", snackbarType: "error"})
                return
            }
            if (this.state.name===null || this.state.name===""){
                this.setState({openSnackbar: true, message: "نام و نام خانوادگی را وارد کنید!", snackbarType: "error"})
            }
            if (list !== null) {
                let products = CardShopRepository.getAll()[0].product.id;
                let counts = CardShopRepository.getAll()[0].count;

                if (list.length > 1) {
                    for (let i = 1; i < list.length; i++) {
                        products += "," + list[i].product.id;
                        counts += "," + list[i].count;
                    }
                }

                fetch(BASE_URL_API + 'order', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        products: products.toString(),
                        counts: counts.toString(),
                        user_agent: "pwa"
                    })
                })
                    .then(response => response.json())
                    .then(result => {
                        console.log(result)
                        if (result.code === 200) {

                            console.log(result.data)
                            window.location.assign(result.data);
                            this.setState({openSnackbar: true, message: "در حال انتقال به درگاه پرداخت..."})

                            // window.location.assign('https://hamekara.com');
                        } else {
                            this.setState({openSnackbar: true, message: result.message, snackbarType: "error"})
                        }


                    })
            }


        };

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }
        const MAX_LENGTH_ADDRESS = 200;

        return (
            <React.Fragment>

                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>{"سبد خرید"}</strong>
                        </ListItemText>


                        <BackButton/>

                    </ToolbarMui>

                </AppBar>




                {
                    this.state.userData !== null ?
                        <div style={{background: '#f5f5f5', marginTop: 65,padding:32}}  alignItems='center' justifyContent='center' align='center'>

                            <div style={{display: 'flex'}}>
                                <img style={{width: 28, height: 28,marginTop:8}} alt="avatar2" src={AvatarRound}/>

                                <Typography style={{
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    flex:12
                                }} align='right'><p style={{
                                    fontSize: 14,
                                    overflow: 'ellipsis',
                                    paddingRight: 8,
                                    color: 'black'
                                }}>{"نام و نام خانوادگی: ‌" + this.state.userData.name}</p>
                                </Typography>
                                    <IconButton component={Link} to={"/profile"}><BorderColorIcon style={{color:'black'}} /></IconButton>
                                </div>

                            <div style={{display: 'flex'}}>
                                <img style={{width: 24, height: 24,marginTop:8}} alt="avatar2" src={Location}/>

                                <Typography style={{
                                    overflow: 'ellipsis',
                                    whiteSpace: 'pre-line',
                                    wordWrap: "break-word",
                                    color: 'black',
                                    fontWeight: 'bold',
                                    flex:12
                                }} align='right'><p style={{
                                    fontSize: 14,
                                    whiteSpace: 'pre-line',
                                    wordWrap: "break-word",
                                    paddingRight: 8,
                                    color: 'black'
                                }}>{"ارسال به: ‌" + this.state.userData.address}</p>
                                </Typography>
                            </div>
                        </div> : ''
                }

                {this.state.cardShopList ===null || this.state.cardShopList.length ===0 ? (
                    <div align='center'>
                        <img style={{width:'20%'}} alt="avatar2" src={EmptyShopCard}/>
                    </div>

                ) : ''}

                <List> {this.state.cardShopList.map((item) => (

                    <ListItem style={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{maxWidth: 500}}>
                            <Paper>
                                <ListItemText style={{align: 'right'}}>

                                    <Grid container>
                                        <Grid item xs={6}>
                                            <p style={{
                                                marginRight: 12,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'green',
                                                fontWeight: 'bold'
                                            }}
                                               align='right'>{item.market.name}
                                            </p>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'gray',
                                                fontSize: 12
                                            }}
                                               align='center'>{"هزینه ارسال: " + item.market.shipping.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}</p>
                                        </Grid>
                                        {item.productList.map((item) => (
                                            <React.Fragment>
                                                <Grid item xs={2}>
                                                    <Paper
                                                        style={{
                                                            width: 45,
                                                            height: 45,
                                                            marginRight: 15,
                                                            marginBottom: 15,
                                                            align: 'center',
                                                            backgroundPosition: 'center',
                                                        }}>
                                                        <img style={{
                                                            width: 45,
                                                            height: 45,
                                                            objectFit: 'cover'
                                                        }}
                                                             src={item.product.pictures.length > 0 ? PRODUCT_BASE_URL_API + item.product.pictures[0].url : "https://hamekara.com/hamekara-logo.png"}/>

                                                    </Paper>
                                                </Grid>
                                                {item.product.title.length > MAX_LENGTH ?
                                                    (
                                                        <Grid item xs={4}>
                                                            <p style={{
                                                                overflow: 'ellipsis', whiteSpace: 'pre-line',
                                                                wordWrap: "break-word", fontSize: 12
                                                            }}
                                                               align='center'>{`${item.product.title.substring(0, MAX_LENGTH)}...`}</p>
                                                        </Grid>
                                                    ) :
                                                    <Grid item xs={4}>
                                                        <p style={{
                                                            overflow: 'ellipsis', whiteSpace: 'pre-line',
                                                            wordWrap: "break-word", fontSize: 12
                                                        }}
                                                           align='center'>{`${item.product.title}`}</p>
                                                    </Grid>
                                                }

                                                <Grid item xs={2}>
                                                    <p style={{
                                                        overflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        fontSize: 12
                                                    }}
                                                       align='center'>{"تعداد: " + item.count}</p>
                                                </Grid>

                                                {
                                                    item.product.price > 0 ?
                                                        <Grid item xs={4}>
                                                            <p style={{
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontSize: 12
                                                            }}
                                                               align='center'>{"مجموع: " + (item.count * (parseInt(item.product.price) - parseInt(item.product.del_price))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}</p>
                                                        </Grid>
                                                        : <Grid item xs={3}>
                                                            <p style={{
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontSize: 12
                                                            }}
                                                               align='center'>{" تماس بگیرید "}</p>
                                                        </Grid>
                                                }

                                                <Grid item xs={12}>
                                                    <IconButton
                                                        color="inherit"
                                                        aria-label="open drawer"
                                                        edge="end"
                                                        onClick={() => handleOnIncrease(item)}
                                                        sx={{...(this.state.open && {display: 'none'})}}>
                                                        <AddCircleIcon style={{padding: 8, color: 'green'}}/>

                                                    </IconButton>

                                                    <IconButton
                                                        color="inherit"
                                                        aria-label="open drawer"
                                                        edge="end"
                                                        onClick={() => handleOnDecrease(item)}
                                                        sx={{...(this.state.open && {display: 'none'})}}>
                                                        <RemoveCircleOutlineIcon style={{padding: 8, color: 'red'}}/>

                                                    </IconButton>
                                                </Grid>

                                            </React.Fragment>
                                        ))
                                        }

                                        <Grid xs={12} style={{width: '100%', background: 'green'}}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                paddingRight: 12,
                                                fontSize: 12,
                                                color: 'white'

                                            }}
                                               align='right'>{"مجموع: " + (parseInt(item.market.shipping) + parseInt(item.total)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}</p>
                                        </Grid>

                                    </Grid>

                                </ListItemText>

                            </Paper>

                        </div>

                    </ListItem>

                ))
                }
                </List>

                {
                    this.state.cardShopList.length > 0 ?
                        <div style={{width: '100%', justifyContent: 'center', alignItems: 'center'}} align='center'>

                            <Button onClick={() => onPaymentCLicked()} variant="contained" style={{
                                color: 'white',
                                margin: 50,
                                background: "green",
                                align: 'center'
                            }}
                                    align='center'>{`تکمیل سفارش (${this.state.totalOrder.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان)`}</Button>
                        </div> : ""
                }


                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>

                <FormPropsTextFields/>

            </React.Fragment>
        );

    }

}
